export default __webpack_public_path__ + "static/media/doc-icon.d1d35e9d.png";